import { cssVar } from '../../theme/variables.js';
import { Content as Content$1 } from '@radix-ui/react-dropdown-menu';
import { keyframes, styled } from 'styled-components';

const inAnimation = keyframes([
  `from{transform:translateY(15px);opacity:0;}to{transform:translateY(0);opacity:1;}`
]);
const outAnimation = keyframes([
  `from{transform:translateY(0);opacity:1;}to{transform:translateY(15px);opacity:0;}`
]);
const Content = styled(Content$1).withConfig({
  displayName: "Content",
  componentId: "sc-4dd1b1c9-0"
})([
  `background:`,
  `;border:`,
  ` 1px solid;box-shadow:0px 1px 13.5px 0px #80808040;border-radius:6px;width:max-content;padding:5px;font-size:12px;font-weight:600;max-height:350px;&[data-state='open']{animation:`,
  ` 0.1s ease-out forwards;}&[data-state='closed']{animation:`,
  ` 0.1s ease-out forwards;}div:has(> &){z-index:126 !important;}`
], cssVar["color-bg-secondary"], cssVar["color-border-primary"], inAnimation, outAnimation);

export { Content };
//# sourceMappingURL=Content.js.map
